const products = [
  {
    id: 1,
    name: "Flower Pot",
    description: "Colorful flower pot crackers for celebrations.",
    youtube: "https://www.youtube.com/embed/1xVw6PsSinI"
  },
  {
    id: 2,
    name: "Sparklers",
    description: "Bright sparklers for kids and adults.",
    youtube: "https://www.youtube.com/embed/2Vv-BfVoq4g"
  },
  {
    id: 3,
    name: "Chakkar",
    description: "Spinning chakkar crackers for fun.",
    youtube: "https://www.youtube.com/embed/3fumBcKC6RE"
  }
];

export default products;
